module.exports = __webpack_public_path__ + "trust-marks-seo-moz.53225c.png";